import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card, Alert, Badge, InputGroup, Tabs, Tab, ProgressBar, Modal } from "react-bootstrap";
import "../componentCss/webform.css";
import { Formik, Field } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Dashboardheader from "./dashboardheader";
import Sidebar from "./sidebar";
import "../componentCss/sidebar.css";
import toast, { Toaster } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import { BsArrowLeftCircleFill, BsEyeSlashFill, BsEyeFill, BsUpload, BsTrash, BsCheck, BsX, BsPencil, BsSave, BsShieldCheck } from "react-icons/bs";
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBuilding, FaIdBadge, FaCalendarAlt, FaImage, FaFileSignature, FaUserTie, FaUserEdit, FaHistory } from "react-icons/fa";
import { MdSecurity, MdWork, MdLocationOn, MdEdit, MdSave, MdCancel, MdInfo, MdWarning } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import config from "../../config/config";
import { Link } from "react-router-dom";
import {
  editStaffSchema,
  basicInfoSchema,
  contactSchema,
  professionalSchema,
  securitySchema,
  filesSchema
} from "../../validations/staffSchema";
import {
  updateStaffAction,
  getStaffDetailsAction,
  getGroupTypesAction,
  getDepartmentListAction
} from "../../Action/modernAdminActions";
import { useMigrationHelper, createMigratedAction } from '../../utils/migrationHelper';
import { decryptData } from './decrypt'
import Select from 'react-select';
import NumericInput from '../common/NumericInput';
import PasswordChangeModal from "../../components/auth/PasswordChangeModal";

const EditStaff = () => {
  const { id } = useParams();

  // Utility function to format dates for HTML date inputs and display
  const formatDateForInput = (dateValue) => {
    if (!dateValue) return '';

    try {
      let date;

      // Handle different date formats from backend
      if (typeof dateValue === 'string') {
        // Try parsing ISO format first (2024-01-15 or 2024-01-15T10:30:00)
        if (dateValue.includes('-') && dateValue.length >= 10) {
          date = new Date(dateValue);
        }
        // Try parsing DD/MM/YYYY format
        else if (dateValue.includes('/')) {
          const [day, month, year] = dateValue.split('/');
          date = new Date(year, month - 1, day);
        }
        // Try parsing other formats
        else {
          date = new Date(dateValue);
        }
      } else {
        date = new Date(dateValue);
      }

      // Validate the date
      if (isNaN(date.getTime())) {
        return '';
      }

      // Return in YYYY-MM-DD format for HTML date inputs
      return date.toISOString().split('T')[0];
    } catch (error) {
      console.warn('Date formatting error:', error);
      return '';
    }
  };

  // Format date for display purposes (user-friendly format)
  const formatDateForDisplay = (dateValue) => {
    if (!dateValue) return 'Not set';

    try {
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return 'Invalid date';

      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return 'Invalid date';
    }
  };
  const navigate = useNavigate();
  const [userGroup, setUserGroup] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [image_file, setimage_file] = useState("");
  const [imagePhotofile, setPhotofile] = useState("");
  const [imageSignature, setSignaturefile] = useState("");
  const [image_preview, setimage_preview] = useState("");
  const [imagePhotoPreview, setPhotopreview] = useState("");
  const [imageSignaturepreview, setSignaturepreview] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [staffDetails, setStaffDetails] = useState({
    name_prefix: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    email: "",
    password: "",
    confirm_password: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    designation: "",
    employee_id: "",
    emirates_id_number: "",
    license_number: "",
    date_of_joining: "",
    photo: "",
    signature: "",
    stamp_image: "",
    gender: 0,
    roles: [],
    is_active: 0,
  });

  const [isLaoding, setisLaoding] = useState(0);
  const [passwordData, setPasswordData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [confirmPasswordData, setConfirmPasswordData] = useState(1);
  const [activeTab, setActiveTab] = useState('basic');
  const [hasChanges, setHasChanges] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const [updateProgress, setUpdateProgress] = useState(0);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordChangeLoading, setPasswordChangeLoading] = useState(false);
  const [editMode, setEditMode] = useState({
    basic: false,
    contact: false,
    professional: false,
    security: false,
    files: false
  });
  const [tabHasChanges, setTabHasChanges] = useState({
    basic: false,
    contact: false,
    professional: false,
    security: false,
    files: false
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [uploadProgress, setUploadProgress] = useState({
    photo: 0,
    signature: 0,
    stamp_image: 0
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [showLeaveConfirmation, setShowLeaveConfirmation] = useState(false);
  const [nextTab, setNextTab] = useState(null);

  // Helper functions for tab management
  const enableTabEdit = (tabKey) => {
    setEditMode(prev => ({ ...prev, [tabKey]: true }));
  };

  const disableTabEdit = (tabKey) => {
    setEditMode(prev => ({ ...prev, [tabKey]: false }));
    setTabHasChanges(prev => ({ ...prev, [tabKey]: false }));
  };

  const setTabChanged = (tabKey, hasChanged) => {
    setTabHasChanges(prev => ({ ...prev, [tabKey]: hasChanged }));
  };

  // Field mappings for each tab
  const tabFieldMappings = {
    basic: ['name_prefix', 'first_name', 'middle_name', 'last_name', 'email', 'gender'],
    contact: ['phone', 'address', 'city', 'state'],
    professional: ['department', 'specialty', 'designation', 'roles', 'employee_id', 'emirates_id_number', 'license_number', 'date_of_joining', 'releavingDate', 'is_active'],
    security: ['password', 'confirm_password'],
    files: ['photo', 'signature', 'stamp_image']
  };

  // Get data for specific tab
  const getTabData = (tabKey, allData) => {
    const fields = tabFieldMappings[tabKey];
    const tabData = {};
    fields.forEach(field => {
      tabData[field] = allData[field];
    });
    return tabData;
  };

  // Tab switching with confirmation for unsaved changes
  const handleTabChange = (newTabKey) => {
    const currentTabHasChanges = Object.values(tabHasChanges).some(changed => changed);
    const currentTabIsEditing = Object.values(editMode).some(editing => editing);

    if (currentTabHasChanges || currentTabIsEditing) {
      setNextTab(newTabKey);
      setShowLeaveConfirmation(true);
    } else {
      setActiveTab(newTabKey);
    }
  };

  const confirmTabLeave = () => {
    // Reset current tab state and switch
    setEditMode({
      basic: false,
      contact: false,
      professional: false,
      security: false,
      files: false
    });
    setTabHasChanges({
      basic: false,
      contact: false,
      professional: false,
      security: false,
      files: false
    });
    setActiveTab(nextTab);
    setShowLeaveConfirmation(false);
    setNextTab(null);
  };

  const cancelTabLeave = () => {
    setShowLeaveConfirmation(false);
    setNextTab(null);
  };

  useEffect(() => {
    getGroupTypesAPI();
    getDepartmentListAPI();
  }, []);

  // Transform department value to React Select format when both staff details and department list are loaded
  useEffect(() => {
    if (isDataLoaded && staffDetails && departmentList.length > 0 && staffDetails.department) {
      const departmentObj = departmentList.find(dept => dept.value === staffDetails.department);
      if (departmentObj) {
        setStaffDetails(prev => ({
          ...prev,
          department: departmentObj
        }));
        setOriginalData(prev => ({
          ...prev,
          department: departmentObj
        }));
      }
    }
  }, [isDataLoaded, staffDetails, departmentList]);

  let getDepartmentListAPI = async () => {
    try {
      let res = await getDepartmentListAction();
      if (res.success) {
        const data = res.data;
        const transformedData = data.map(item => ({
          value: String(item.id || item.department_id).replace(/"/g, ''),
          label: item.name
        }));
        setDepartmentList(transformedData);
      }
    } catch (error) {
      toast.error('Failed to load departments');
    }
  };

  let getGroupTypesAPI = async (values) => {
    let res = await getGroupTypesAction(values);
    if (res.success) {
      const data = res.data
      const transformedData = data.map(item => ({
        value: item.id || item.role_id,
        label: item.name
      }));
      setUserGroup(transformedData);
    }
  };

  const [timeSlots, setTimeSlots] = useState({
    Sunday: { selected: false, from: null, to: null },
    Monday: { selected: false, from: null, to: null },
    Tuesday: { selected: false, from: null, to: null },
    Wednesday: { selected: false, from: null, to: null },
    Thursday: { selected: false, from: null, to: null },
    Friday: { selected: false, from: null, to: null },
    Saturday: { selected: false, from: null, to: null },
  });

  useEffect(() => {
    // Function to map the API response to the timeSlots state format
    const mapApiResponseToTimeSlots = (apiResponse) => {
      const updatedTimeSlots = { ...timeSlots };

      apiResponse.forEach(({ day, from, to }) => {
        updatedTimeSlots[day] = {
          selected: true,
          from: from.slice(0, 5), // Convert "09:35:00.000000" to "09:35"
          to: to.slice(0, 5), // Convert "18:34:00.000000" to "18:34"
        };
      });

      return updatedTimeSlots;
    };

    const getStaffDetailsAPI = async () => {
      if (!id || typeof id !== 'string') {
        toast.error('Invalid user ID');
        return;
      }

      try {
        let res = await getStaffDetailsAction(id);

        if (res.success) {
          // Handle the wrapped response format - the actual user data is in res.data.data
          const userData = res.data.data || res.data;

          // Add default values for missing fields and map API response to form structure
          const staffDataWithDefaults = {
            ...userData,
            name_prefix: userData.name_prefix || '',
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            middle_name: userData.middle_name || '',
            email: userData.email || '',
            phone: userData.phone || '',
            address: userData.address || '',
            city: userData.city || '',
            state: userData.state || '',
            designation: userData.designation || '',
            employee_id: userData.employee_id || '',
            gender: userData.gender || '',
            emirates_id_number: userData.emirates_id_number || '',
            date_of_joining: formatDateForInput(userData.date_of_joining),
            releavingDate: formatDateForInput(userData.releavingDate),
            license_number: userData.license_number || '',
            is_active: userData.is_active !== undefined ? userData.is_active : true,
            photo: userData.photo || null,
            signature: userData.signature || null,
            stamp_image: userData.stamp_image || null,
            // Convert roles from strings to objects for form validation
            roles: (userData.roles || []).map(role => {
              if (typeof role === 'string') {
                // Find the role object from userGroup options
                const roleOption = userGroup.find(opt => opt.value === role);
                return roleOption || { value: role, label: role };
              }
              return role; // Already an object
            }),
            department: userData.department || '',
            specialty: userData.specialty || '',
            // Clear password fields for security
            password: '',
            confirm_password: ''
          };

          // Set the raw API response directly without transformation
          setStaffDetails(staffDataWithDefaults);
          // Also set original data for change tracking
          setOriginalData(staffDataWithDefaults);
          // Mark data as loaded
          setIsDataLoaded(true);
        } else {
          toast.error(res.message || "Failed to fetch staff details.");
        }
      } catch (error) {
        toast.error("An error occurred while fetching staff details.");
      }
    };

    getStaffDetailsAPI();
  }, [id]);

  // Tab-specific submission handlers
  const handleTabSubmit = async (tabKey, values, actions) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setisLaoding(1);
    setBackendErrors({});

    try {
      // Get only the fields for this tab
      const tabData = getTabData(tabKey, values);

      // Create submission data with staff ID
      const submissionData = {
        id: staffDetails?.id,
        ...tabData
      };

      // Special handling for different tabs
      if (tabKey === 'professional') {
        submissionData.department = values.department ? String(values.department.value).replace(/"/g, '') : undefined;
        submissionData.roles = values.roles ? values.roles.map(role => typeof role === 'object' ? role.value : role) : [];
      }

      // Clean up empty password fields for security tab
      if (tabKey === 'security' && !submissionData.password) {
        delete submissionData.password;
        delete submissionData.confirm_password;
      }

      const progressInterval = setInterval(() => {
        setUpdateProgress(prev => prev < 90 ? prev + 10 : prev);
      }, 200);

      let res = await updateStaffAction(id, submissionData, originalData);

      clearInterval(progressInterval);
      setUpdateProgress(100);

      if (res.success) {
        toast.success(`${tabKey.charAt(0).toUpperCase() + tabKey.slice(1)} information updated successfully`);

        // Update the local staff data with new values
        setStaffDetails(prev => ({
          ...prev,
          ...tabData
        }));
        setOriginalData(prev => ({
          ...prev,
          ...tabData
        }));

        // Reset tab edit state
        disableTabEdit(tabKey);

        setTimeout(() => setUpdateProgress(0), 1000);
      } else {
        // Handle backend validation errors
        if (res.errors && typeof res.errors === 'object') {
          Object.keys(res.errors).forEach(field => {
            const errorMessage = Array.isArray(res.errors[field])
              ? res.errors[field][0]
              : res.errors[field];
            actions.setFieldError(field, errorMessage);

            // Focus on first field with error
            setTimeout(() => {
              const firstErrorField = document.querySelector(`[name="${field}"]`);
              if (firstErrorField) {
                firstErrorField.focus();
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }, 100);
          });
          setBackendErrors(res.errors);
          toast.error("Please correct the highlighted errors and try again.");
        } else {
          toast.error(res.message || res.msg || "Failed to update information");
        }
        setUpdateProgress(0);
      }
    } catch (error) {
      console.error('Tab submission error:', error);

      // Handle RBAC/Permission errors (403) explicitly
      const status = error?.response?.status;
      if (status === 403) {
        toast.error(error?.response?.data?.detail || 'You do not have permission to update staff.');
        setUpdateProgress(0);
        return;
      }

      toast.error("An unexpected error occurred. Please try again.");
      setUpdateProgress(0);
    } finally {
      setisLaoding(0);
      setIsSubmitting(false);
      if (actions) actions.setSubmitting(false);
    }
  };

  const detectChanges = (values) => {
    const changed = JSON.stringify(values) !== JSON.stringify(originalData);
    setHasChanges(changed);
    return changed;
  };

  const handleFieldChange = (fieldName, value, setFieldValue) => {
    setFieldValue(fieldName, value);
    setHasChanges(true);
  };

  const resetForm = (resetForm) => {
    resetForm();
    setHasChanges(false);
    setEditMode({
      basic: false,
      contact: false,
      professional: false,
      security: false,
      files: false
    });
    setTabHasChanges({
      basic: false,
      contact: false,
      professional: false,
      security: false,
      files: false
    });
  };

  const getStatusBadge = (isActive) => {
    return (
      <Badge bg={isActive ? 'success' : 'secondary'}>
        {isActive ? 'Active' : 'Inactive'}
      </Badge>
    );
  };

  const getRoleBadges = (roles) => {
    if (!roles || roles.length === 0) return <span className="text-muted">No roles assigned</span>;
    return roles.map((role, index) => (
      <Badge key={index} bg="primary" className="me-1">
        {typeof role === 'string' ? role : (typeof role === 'object' && role.label ? role.label : String(role))}
      </Badge>
    ));
  };

  const handleChangeForstampImage = async (e, setFieldValue) => {
    e.preventDefault();
    let image_as_base64 = URL.createObjectURL(e.target.files[0]);
    let image_as_files = e.target.files[0];

    setFieldValue("stamp_image", image_as_files);
    setimage_file(image_as_files);
    setimage_preview(image_as_base64);
  };

  const handleChangeForPhoto = async (e, setFieldValue) => {
    e.preventDefault();
    let image_as_base64 = URL.createObjectURL(e.target.files[0]);
    let image_as_files = e.target.files[0];

    setFieldValue("photo", image_as_files);
    setPhotofile(image_as_files);
    setPhotopreview(image_as_base64);
  };

  const handleChangeForSignature = async (e, setFieldValue) => {
    e.preventDefault();
    let image_as_base64 = URL.createObjectURL(e.target.files[0]);
    let image_as_files = e.target.files[0];

    setFieldValue("signature", image_as_files);
    setSignaturefile(image_as_files);
    setSignaturepreview(image_as_base64);
  };

  // Tab Control Component
  const TabEditControls = ({ tabKey, isEditing, hasChanges, onEdit, onCancel, isLoading }) => (
    <div className="d-flex justify-content-end">
      {!isEditing ? (
        <Button
          variant="primary"
          size="sm"
          onClick={() => onEdit(tabKey)}
          className="d-flex align-items-center gap-2"
        >
          <MdEdit size={16} />
          Edit Information
        </Button>
      ) : (
        <div className="d-flex gap-2">
          <Button
            variant="success"
            size="sm"
            type="submit"
            disabled={isLoading}
            className="d-flex align-items-center gap-2"
          >
            <MdSave size={16} />
            Save Changes
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => onCancel(tabKey)}
            disabled={isLoading}
            className="d-flex align-items-center gap-2"
          >
            <MdCancel size={16} />
            Cancel
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <>
      <Dashboardheader />
      <div className="wrapper">
        <Sidebar />
        <div id="content">
          <Container fluid className="p-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h5 className="headtitle mb-1">
                      <FaUserEdit className="me-2" />
                      Edit Staff Member
                    </h5>
                    <small className="text-muted">Update staff information and permissions</small>
                  </div>
                  <div className="d-flex gap-2">
                    {(hasChanges || Object.values(tabHasChanges).some(changed => changed)) && (
                      <Alert variant="warning" className="p-2 mb-0 d-flex align-items-center">
                        <MdWarning className="me-1" />
                        <small>You have unsaved changes</small>
                      </Alert>
                    )}
                    <Link to={`${config.baseUrl}staff-management`}>
                      <Button variant="outline-secondary" size="sm" className="d-flex align-items-center gap-2">
                        <BsArrowLeftCircleFill size={16} />
                        Back to Staff List
                      </Button>
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                {/* Staff Overview Card */}
                <Card className="border-0 shadow-sm mb-4">
                  <Card.Body className="p-4">
                    <Row className="align-items-center">
                      <Col md={2} className="text-center">
                        <div className="position-relative">
                          {staffDetails.photo ? (
                            <img
                              src={staffDetails.photo}
                              alt="Staff Photo"
                              className="rounded-circle"
                              style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                            />
                          ) : (
                            <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                              <FaUser size={32} className="text-white" />
                            </div>
                          )}
                          {getStatusBadge(staffDetails.is_active)}
                        </div>
                      </Col>
                      <Col md={10}>
                        <Row>
                          <Col md={6}>
                            <h6 className="mb-1">
                              {staffDetails.name_prefix} {staffDetails.first_name} {staffDetails.last_name}
                            </h6>
                            <p className="text-muted mb-2">{staffDetails.designation || 'No designation'}</p>
                            <div className="mb-2">
                              <small className="text-muted">Roles: </small>
                              {getRoleBadges(staffDetails.roles)}
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="text-end">
                              <p className="mb-1"><strong>Employee ID:</strong> {staffDetails.employee_id || 'Not set'}</p>
                              <p className="mb-1"><strong>Email:</strong> {staffDetails.email}</p>
                              <p className="mb-1"><strong>Department:</strong> {typeof staffDetails.department === 'object' ? staffDetails.department.label : (staffDetails.department || 'Not assigned')}</p>
                              <p className="mb-1"><strong>Joined:</strong> {formatDateForDisplay(staffDetails.date_of_joining)}</p>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="border-0 shadow-sm">
                  <Card.Body className="p-4">
                    {/* Progress Bar */}
                    {/* {isLaoding && (
                      <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-muted">Updating staff member...</span>
                          <span className="text-primary">{updateProgress}%</span>
                        </div>
                        <ProgressBar now={updateProgress} variant="primary" style={{ height: '6px' }} />
                      </div>
                    )} */}

                    {/* Tabbed Interface */}
                    <Tabs activeKey={activeTab} onSelect={handleTabChange} className="mb-4">
                      <Tab eventKey="basic" title={<span><FaUser className="me-2" />Basic Information</span>}>
                        <div className="pt-3">
                          <Formik
                            enableReinitialize={true}
                            initialValues={getTabData('basic', staffDetails)}
                            validationSchema={basicInfoSchema}
                            onSubmit={(values, actions) => handleTabSubmit('basic', values, actions)}
                          >
                            {({ errors, handleSubmit, handleBlur, handleChange, setFieldValue, touched, values, isSubmitting }) => (
                              <Form onSubmit={handleSubmit}>
                                <Row className="mb-4">
                                  <Form.Group as={Col} lg={3}>
                                    <Form.Label>Prefix</Form.Label>
                                    <Form.Select
                                      name="name_prefix"
                                      onChange={handleChange}
                                      value={values.name_prefix}
                                      disabled={!editMode.basic}
                                    >
                                      <option value="Mr">Mr</option>
                                      <option value="Ms">Ms</option>
                                      <option value="Miss">Miss</option>
                                      <option value="Mrs">Mrs</option>
                                      <option value="Master">Master</option>
                                      <option value="Fr">Father (Fr)</option>
                                      <option value="Rev">Reverend (Rev)</option>
                                      <option value="Dr">Doctor (Dr)</option>
                                      <option value="Atty">Attorney (Atty)</option>
                                      <option value="Hon">Honorable (Hon)</option>
                                      <option value="Prof">Professor (Prof)</option>
                                      <option value="Pres">President (Pres)</option>
                                      <option value="VP">Vice President (VP)</option>
                                      <option value="Gov">Governor (Gov)</option>
                                    </Form.Select>
                                  </Form.Group>
                                  <Col lg={9}>
                                    <TabEditControls
                                      tabKey="basic"
                                      isEditing={editMode.basic}
                                      hasChanges={tabHasChanges.basic}
                                      onEdit={enableTabEdit}
                                      onCancel={disableTabEdit}
                                      isLoading={isLaoding}
                                    />
                                  </Col>
                                </Row>

                                <h6 className="text-muted mb-3">
                                  <FaUser className="me-2" />Personal Information
                                </h6>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FaUser size={16} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        name="first_name"
                                        onChange={(e) => {
                                          handleChange(e);
                                          setTabChanged('basic', true);
                                        }}
                                        onBlur={handleBlur}
                                        value={values.first_name}
                                        disabled={!editMode.basic}
                                        isInvalid={(errors.first_name && touched.first_name) || backendErrors.first_name}
                                        isValid={!errors.first_name && touched.first_name && values.first_name}
                                        placeholder="Enter first name"
                                      />
                                    </InputGroup>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.first_name || backendErrors.first_name}
                                    </Form.Control.Feedback>
                                  </Form.Group>

                                  <Form.Group as={Col}>
                                    <Form.Label>Middle Name</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="middle_name"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('basic', true);
                                      }}
                                      onBlur={handleBlur}
                                      value={values.middle_name}
                                      disabled={!editMode.basic}
                                      placeholder="Optional"
                                      isInvalid={errors.middle_name && touched.middle_name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.middle_name}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FaUser size={16} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        name="last_name"
                                        onChange={(e) => {
                                          handleChange(e);
                                          setTabChanged('basic', true);
                                        }}
                                        onBlur={handleBlur}
                                        value={values.last_name}
                                        disabled={!editMode.basic}
                                        isInvalid={(errors.last_name && touched.last_name) || backendErrors.last_name}
                                        isValid={!errors.last_name && touched.last_name && values.last_name}
                                        placeholder="Enter last name"
                                      />
                                    </InputGroup>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.last_name || backendErrors.last_name}
                                    </Form.Control.Feedback>
                                  </Form.Group>

                                  <Form.Group as={Col}>
                                    <Form.Label>Gender <span className="text-danger">*</span></Form.Label>
                                    <Form.Select
                                      name="gender"
                                      value={values.gender}
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('basic', true);
                                      }}
                                      onBlur={handleBlur}
                                      disabled={!editMode.basic}
                                      isInvalid={(errors.gender && touched.gender) || backendErrors.gender}
                                    >
                                      <option value="">Select gender</option>
                                      <option value="1">Male</option>
                                      <option value="2">Female</option>
                                      <option value="3">Other</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.gender || backendErrors.gender}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FaEnvelope size={16} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="email"
                                        name="email"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        disabled
                                        className="bg-light"
                                        isInvalid={backendErrors.email}
                                      />
                                    </InputGroup>
                                    <Form.Text className="text-muted">
                                      <MdInfo size={14} className="me-1" />
                                      Email cannot be changed for security reasons
                                    </Form.Text>
                                    {backendErrors.email && (
                                      <div className="text-danger small mt-1">
                                        {backendErrors.email}
                                      </div>
                                    )}
                                  </Form.Group>
                                </Row>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </Tab>

                      <Tab eventKey="contact" title={<span><FaPhone className="me-2" />Contact & Location</span>}>
                        <div className="pt-3">
                          <Formik
                            enableReinitialize={true}
                            initialValues={getTabData('contact', staffDetails)}
                            validationSchema={contactSchema}
                            onSubmit={(values, actions) => handleTabSubmit('contact', values, actions)}
                          >
                            {({ errors, handleSubmit, handleBlur, handleChange, setFieldValue, touched, values, isSubmitting }) => (
                              <Form onSubmit={handleSubmit}>
                                <h6 className="text-muted mb-3">
                                  <FaPhone className="me-2" />Contact Information
                                </h6>
                                <Row className="mb-3">
                                  <Col lg={3}></Col>
                                  <Col lg={9}>
                                    <TabEditControls
                                      tabKey="contact"
                                      isEditing={editMode.contact}
                                      hasChanges={tabHasChanges.contact}
                                      onEdit={enableTabEdit}
                                      onCancel={disableTabEdit}
                                      isLoading={isLaoding}
                                    />
                                  </Col>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Phone Number <span className="text-danger">*</span></Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FaPhone size={16} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="tel"
                                        name="phone"
                                        onChange={(e) => {
                                          handleChange(e);
                                          setTabChanged('contact', true);
                                        }}
                                        onBlur={handleBlur}
                                        value={values.phone}
                                        disabled={!editMode.contact}
                                        placeholder="e.g., 971501234567 or +971 50 123 4567"
                                        isInvalid={(errors.phone && touched.phone) || backendErrors.phone}
                                        isValid={!errors.phone && touched.phone && values.phone}
                                      />
                                    </InputGroup>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.phone || backendErrors.phone}
                                    </Form.Control.Feedback>
                                    <Form.Text className="text-muted">
                                      Include country code if applicable (e.g., +971 for UAE)
                                    </Form.Text>
                                  </Form.Group>
                                </Row>

                                <h6 className="text-muted mb-3 mt-4">
                                  <FaMapMarkerAlt className="me-2" />Address Information
                                </h6>

                                <Row className="mb-4">
                                  <Form.Group as={Col} md={12}>
                                    <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FaMapMarkerAlt size={16} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        name="address"
                                        onChange={(e) => {
                                          handleChange(e);
                                          setTabChanged('contact', true);
                                        }}
                                        onBlur={handleBlur}
                                        value={values.address}
                                        disabled={!editMode.contact}
                                        placeholder="Enter full address"
                                        isInvalid={(errors.address && touched.address) || backendErrors.address}
                                      />
                                    </InputGroup>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.address || backendErrors.address}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>City <span className="text-danger">*</span></Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <MdLocationOn size={16} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        name="city"
                                        onChange={(e) => {
                                          handleChange(e);
                                          setTabChanged('contact', true);
                                        }}
                                        onBlur={handleBlur}
                                        value={values.city}
                                        disabled={!editMode.contact}
                                        placeholder="Enter city name"
                                        isInvalid={(errors.city && touched.city) || backendErrors.city}
                                      />
                                    </InputGroup>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.city || backendErrors.city}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  <Form.Group as={Col}>
                                    <Form.Label>State/Emirate <span className="text-danger">*</span></Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <MdLocationOn size={16} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        name="state"
                                        onChange={(e) => {
                                          handleChange(e);
                                          setTabChanged('contact', true);
                                        }}
                                        onBlur={handleBlur}
                                        value={values.state}
                                        disabled={!editMode.contact}
                                        placeholder="Enter state or emirate"
                                        isInvalid={(errors.state && touched.state) || backendErrors.state}
                                      />
                                    </InputGroup>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.state || backendErrors.state}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Row>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </Tab>

                      <Tab eventKey="professional" title={<span><FaBuilding className="me-2" />Professional</span>}>
                        <div className="pt-3">
                          <Formik
                            enableReinitialize={true}
                            initialValues={getTabData('professional', staffDetails)}
                            validationSchema={professionalSchema}
                            onSubmit={(values, actions) => handleTabSubmit('professional', values, actions)}
                          >
                            {({ errors, handleSubmit, handleBlur, handleChange, setFieldValue, touched, values, isSubmitting }) => (
                              <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                  <Col lg={3}></Col>
                                  <Col lg={9}>
                                    <TabEditControls
                                      tabKey="professional"
                                      isEditing={editMode.professional}
                                      hasChanges={tabHasChanges.professional}
                                      onEdit={enableTabEdit}
                                      onCancel={disableTabEdit}
                                      isLoading={isLaoding}
                                    />
                                  </Col>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Department</Form.Label>
                                    <Select
                                      name="department"
                                      options={departmentList}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      onChange={(selectedOption) => {
                                        setFieldValue("department", selectedOption);
                                        setTabChanged('professional', true);
                                      }}
                                      onBlur={handleBlur}
                                      value={values.department}
                                      isDisabled={!editMode.professional}
                                    />
                                    {errors.department && touched.department && (
                                      <div className="text-danger">
                                        {errors.department}
                                      </div>
                                    )}
                                  </Form.Group>
                                  <Form.Group as={Col}>
                                    <Form.Label>Specialty</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="specialty"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      onBlur={handleBlur}
                                      value={values.specialty}
                                      disabled={!editMode.professional}
                                      placeholder="Please enter specialty"
                                    />
                                    {errors.specialty && touched.specialty && (
                                      <div className="text-danger">{errors.specialty}</div>
                                    )}
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Designation</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="designation"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      onBlur={handleBlur}
                                      value={values.designation}
                                      disabled={!editMode.professional}
                                      placeholder="Enter designation"
                                    />
                                    {errors.designation && touched.designation && (
                                      <div className="text-danger">{errors.designation}</div>
                                    )}
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Roles</Form.Label>
                                    <Field
                                      name="roles"
                                      component={MultiSelectField}
                                      options={userGroup}
                                      staffDetails={staffDetails}
                                      disabled={!editMode.professional}
                                      onChange={() => setTabChanged('professional', true)}
                                    />
                                    {errors.roles && touched.roles && (
                                      <div className="text-danger">{errors.roles}</div>
                                    )}
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Employee ID</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="employee_id"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      value={values.employee_id}
                                      disabled={!editMode.professional}
                                      placeholder="Please enter Employee Id"
                                    />
                                    {errors.employee_id && touched.employee_id && (
                                      <div className="text-danger">
                                        {errors.employee_id}
                                      </div>
                                    )}
                                  </Form.Group>

                                  <Form.Group as={Col}>
                                    <Form.Label>Emirates ID Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="emirates_id_number"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      value={values.emirates_id_number}
                                      disabled={!editMode.professional}
                                      placeholder="Please enter Emirates ID Number"
                                    />
                                    {errors.emirates_id_number && touched.emirates_id_number && (
                                      <div className="text-danger">
                                        {errors.emirates_id_number}
                                      </div>
                                    )}
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Date of Joining</Form.Label>
                                    <Form.Control
                                      type="date"
                                      name="date_of_joining"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      value={values.date_of_joining}
                                      disabled={!editMode.professional}
                                      placeholder="Please enter Date of Joining"
                                    />
                                    {errors.date_of_joining && touched.date_of_joining && (
                                      <div className="text-danger">
                                        {errors.date_of_joining}
                                      </div>
                                    )}
                                  </Form.Group>

                                  <Form.Group as={Col}>
                                    <Form.Label>License Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="license_number"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      placeholder="Please enter License Number"
                                      value={values.license_number}
                                      disabled={!editMode.professional}
                                    />
                                    {errors.license_number && touched.license_number && (
                                      <div className="text-danger">
                                        {errors.license_number}
                                      </div>
                                    )}
                                  </Form.Group>
                                </Row>

                                <Row className="mb-4">
                                  <Form.Group as={Col}>
                                    <Form.Label>Date of Relieving</Form.Label>
                                    <Form.Control
                                      type="date"
                                      name="releavingDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      value={values.releavingDate}
                                      disabled={!editMode.professional}
                                      placeholder="Please enter Date of Relieving"
                                    />
                                  </Form.Group>

                                  <Form.Group as={Col}>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                      name="is_active"
                                      value={values.is_active}
                                      onChange={(e) => {
                                        handleChange(e);
                                        setTabChanged('professional', true);
                                      }}
                                      disabled={!editMode.professional}
                                    >
                                      <option value={1}>Active</option>
                                      <option value={0}>Inactive</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Row>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </Tab>

                      <Tab eventKey="security" title={<span><BsShieldCheck className="me-2" />Security</span>}>
                        <div className="pt-3">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="mb-0">Password Management</h6>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => setShowPasswordModal(true)}
                            >
                              <MdSecurity className="me-1" />
                              Change Password
                            </Button>
                          </div>
                          <Alert variant="info">
                            <MdInfo className="me-2" />
                            For security reasons, passwords can only be changed through the secure password change dialog.
                          </Alert>
                        </div>
                      </Tab>

                      <Tab eventKey="files" title={<span><FaImage className="me-2" />Documents</span>}>
                        <div className="pt-3">
                          <Formik
                            enableReinitialize={true}
                            initialValues={getTabData('files', staffDetails)}
                            validationSchema={filesSchema}
                            onSubmit={(values, actions) => handleTabSubmit('files', values, actions)}
                          >
                            {({ errors, handleSubmit, handleBlur, handleChange, setFieldValue, touched, values, isSubmitting }) => (
                              <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                  <Col lg={3}></Col>
                                  <Col lg={9}>
                                    <TabEditControls
                                      tabKey="files"
                                      isEditing={editMode.files}
                                      hasChanges={tabHasChanges.files}
                                      onEdit={enableTabEdit}
                                      onCancel={disableTabEdit}
                                      isLoading={isLaoding}
                                    />
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={4}>
                                    <Card className="border-0 shadow-sm">
                                      <Card.Body className="text-center">
                                        <h6>Profile Photo</h6>
                                        {imagePhotoPreview ? (
                                          <img src={imagePhotoPreview} width="100" height="100" className="rounded-circle object-fit-cover" alt="Profile Photo Preview" />
                                        ) : staffDetails.photo ? (
                                          <img src={staffDetails.photo} width="100" height="100" className="rounded-circle object-fit-cover" alt="Profile Photo" />
                                        ) : (
                                          <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto" style={{ width: '100px', height: '100px' }}>
                                            <FaUser size={40} className="text-muted" />
                                          </div>
                                        )}
                                        <Form.Control
                                          type="file"
                                          name="photo"
                                          accept="image/*"
                                          onChange={(e) => {
                                            handleChangeForPhoto(e, setFieldValue);
                                            setTabChanged('files', true);
                                          }}
                                          className="mt-3"
                                          size="sm"
                                          disabled={!editMode.files}
                                        />
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                  <Col md={4}>
                                    <Card className="border-0 shadow-sm">
                                      <Card.Body className="text-center">
                                        <h6>Digital Signature</h6>
                                        {imageSignaturepreview ? (
                                          <img src={imageSignaturepreview} width="100" height="60" className="border" alt="Signature Preview" />
                                        ) : staffDetails.signature ? (
                                          <img src={staffDetails.signature} width="100" height="60" className="border" alt="Digital Signature" />
                                        ) : (
                                          <div className="bg-light border d-flex align-items-center justify-content-center mx-auto" style={{ width: '100px', height: '60px' }}>
                                            <FaFileSignature size={24} className="text-muted" />
                                          </div>
                                        )}
                                        <Form.Control
                                          type="file"
                                          name="signature"
                                          accept="image/*"
                                          onChange={(e) => {
                                            handleChangeForSignature(e, setFieldValue);
                                            setTabChanged('files', true);
                                          }}
                                          className="mt-3"
                                          size="sm"
                                          disabled={!editMode.files}
                                        />
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                  <Col md={4}>
                                    <Card className="border-0 shadow-sm">
                                      <Card.Body className="text-center">
                                        <h6>Stamp Image</h6>
                                        {image_preview ? (
                                          <img src={image_preview} width="100" height="100" className="rounded object-fit-cover" alt="Stamp Image Preview" />
                                        ) : staffDetails.stamp_image ? (
                                          <img src={staffDetails.stamp_image} width="100" height="100" className="rounded object-fit-cover" alt="Stamp Image" />
                                        ) : (
                                          <div className="bg-light rounded d-flex align-items-center justify-content-center mx-auto" style={{ width: '100px', height: '100px' }}>
                                            <FaImage size={32} className="text-muted" />
                                          </div>
                                        )}
                                        <Form.Control
                                          type="file"
                                          name="stamp_image"
                                          accept="image/*"
                                          onChange={(e) => {
                                            handleChangeForstampImage(e, setFieldValue);
                                            setTabChanged('files', true);
                                          }}
                                          className="mt-3"
                                          size="sm"
                                          disabled={!editMode.files}
                                        />
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                </Row>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </Tab>
                    </Tabs>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>

          {/* Confirmation Modal for Tab Leave */}
          <Modal show={showLeaveConfirmation} onHide={cancelTabLeave}>
            <Modal.Header closeButton>
              <Modal.Title>Unsaved Changes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              You have unsaved changes. Are you sure you want to leave this tab? Your changes will be lost.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={cancelTabLeave}>
                Cancel
              </Button>
              <Button variant="danger" onClick={confirmTabLeave}>
                Leave without saving
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Password Change Modal */}
          <PasswordChangeModal
            visible={showPasswordModal}
            onCancel={() => setShowPasswordModal(false)}
            onSuccess={(result) => {
              toast.success('Password changed successfully!');
              setShowPasswordModal(false);
            }}
            title="Change Password"
            description="Update the password for this user account"
            isAdminReset={true}
            userId={id}
          />
        </div>
      </div>
    </>
  );
};

// Custom Select Component for Formik
const MultiSelectField = ({ options, field, form, staffDetails, disabled, onChange }) => {
  const handleChange = (selectedOptions) => {
    // Keep the objects as they are for validation
    form.setFieldValue(field.name, selectedOptions || []);
    // Call the onChange callback if provided
    if (onChange) {
      onChange();
    }
  };

  // Determine the current value from form state, fallback to converted staffDetails.roles
  let currentValue = field.value || [];

  // If currentValue is an array of strings (from initial load), convert to objects
  if (currentValue.length > 0 && typeof currentValue[0] === 'string') {
    currentValue = currentValue.map(roleString => {
      const option = options.find(opt => opt.value === roleString);
      return option || { value: roleString, label: roleString };
    });
    // Update the form with the converted objects
    form.setFieldValue(field.name, currentValue);
  }

  return (
    <Select
      name="roles"
      value={currentValue}
      isMulti
      onChange={handleChange}
      className="basic-multi-select"
      classNamePrefix="select"
      options={options}
      placeholder="Select roles"
      isDisabled={disabled}
    />
  );
};

export default EditStaff;